
// campaign type
export const CAMPAIGN_TYPE_COLUMNS = [
    
    {
      id: "0",
      title: "Campaign Type",
      key: "campaign_name",
      visible: true,
      locked: true,
      category: "Recommended",
      type: "boolean",
    },
    {
      id: "1",
      title: "Spend",
      key: "costs",
      visible: true,
      category: "Performance",
      type: "currency",
    },
    {
      id: "2",
      title: `Budget for This Month`,
      key: `Total Budget for "this month"`,
      visible: true,
      category: "Performance",
      type: "currency",
      nonExpand: true,
    },
    {
      id: "3",
      title: "Remaining Budget",
      key: "remaining_budget",
      visible: true,
      category: "Performance",
      type: "currency",
      nonExpand: true,
    },
    {
      id: "10",
      title: "Impr.",
      key: "impressions",
      visible: true,
      category: "Performance",
      type: "number",
    },
    {
      id: "13",
      title: "Clicks",
      key: "clicks",
      visible: true,
      category: "Performance",
      type: "number",
    },
    {
      id: "14",
      title: "CTR",
      key: "ctr",
      visible: true,
      category: "Performance",
      type: "percentage",
      calculation: {
        numerator: "clicks",
        denominator: "impressions",
        multiplier: 100,
      },
    },
    {
      id: "5",
      title: "Avg.CPC",
      key: "average_cpc",
      visible: true,
      category: "Performance",
      type: "currency",
      calculation: { numerator: "costs", denominator: "clicks" },
    },
    {
      id: "8",
      title: "Conversion",
      key: "conversion",
      visible: true,
      category: "Conversion",
      type: "float-no-perc",
    },
    {
      id: "9",
      title: "Cost / conv.",
      key: "cost_per_conversion",
      visible: true,
      category: "Conversion",
      type: "currency",
      calculation: { numerator: "costs", denominator: "conversion" },
    },
    {
      id: "15",
      title: "Spend to Date",
      key: "spend_to_date",
      visible: true,
      category: "Performance",
      type: "currency",
    },
    {
      id: "16",
      title: "Yesterday Spend",
      key: "yesterday_spend",
      visible: true,
      category: "Performance",
      type: "currency",
    },
];

export const GROUP_CAMPAIGN_TYPE_COLUMNS = [
  { id: "0", title: "Group Name", key: "group_name", visible: true, category: "Attributes", type: "string" },
  { id: "1", title: "Campaign Type", key: "campaign_type", visible: true, category: "Attributes", type: "boolean" },
  { id: "2", title: "Cost", key: "costs", visible: true, category: "Performance", type: "currency" },
  { id: "3", title: "Impr.", key: "impressions", visible: true, category: "Performance", type: "number" },
  { id: "4", title: "Clicks", key: "clicks", visible: true, category: "Performance", type: "number" },
  { id: "5", title: "CTR", key: "ctr", visible: true, category: "Performance", type: "percentage", calculation: { numerator: "clicks", denominator: "impressions", multiplier: 100 } },
  { id: "6", title: "Avg. CPC", key: "average_cpc", visible: true, category: "Performance", type: "currency", calculation: { numerator: "costs", denominator: "clicks" } },
  { id: "7", title: "Interactions", key: "interactions", visible: true, category: "Performance", type: "number" },
  { id: "8", title: "Interaction rate", key: "interaction_rate", visible: true, category: "Performance", type: "percentage", calculation: { numerator: "interactions", denominator: "impressions", multiplier: 100 } },
  { id: "9", title: "Conversions", key: "conversions", visible: true, category: "Conversions", type: "float-no-perc" },
  { id: "10", title: "Cost / conv.", key: "cost_per_conversion", visible: true, category: "Conversions", type: "currency", calculation: { numerator: "costs", denominator: "conversions" } },
  { id: "11", title: "Conv. rate", key: "conversion_rate", visible: true, category: "Conversions", type: "percentage", calculation: { numerator: "conversions", denominator: "clicks", multiplier: 100 } },
  { id: "90", title: "Avg. CPM", key: "average_cpm", visible: false, category: "Performance", type: "currency", calculation: { numerator: "costs", denominator: "impressions", multiplier: 1000 } },
  { id: "91", title: "Avg. Cost", key: "average_cost", visible: false, category: "Performance", type: "currency", calculation: { numerator: "costs", denominator: "interactions" } },
  { id: "92", title: "Avg. CPV", key: "average_cpv", visible: false, category: "Performance", type: "currency", calculation: { numerator: "costs", denominator: "video_views" } }
];


// device cols
export const DEVICE_ADDTABLE_COLUMNS = [
  { id: "0", title: "Device", key: "device", visible: true, category: "Recommended", locked: true, isLocked: true, keyType: "string", type: "boolean" },
  { id: "1", title: "Impr.", key: "impressions", category: "Performance", visible: true, isLocked: false, keyType: "number", type: "number" },
  { id: "2", title: "Clicks", key: "clicks", category: "Performance", visible: true, isLocked: false, keyType: "number", type: "number" },
  { id: "3", title: "CTR", key: "ctr", category: "Performance", visible: true, isLocked: false, keyType: "number", type: "float", calculation: { numerator: "clicks", denominator: "impressions", multiplier: 100 } },
  { id: "4", title: "Cost", key: "cost", category: "Performance", visible: true, isLocked: false, keyType: "number", type: "currency" },
  { id: "5", title: "Conversions", key: "conversions", category: "Conversion", visible: true, isLocked: false, keyType: "number", type: "float-no-perc" },
  { id: "6", title: "Conv. Rate", key: "conversion_rate", category: "Conversion", visible: true, isLocked: false, keyType: "number", type: "float", calculation: { numerator: "conversions", denominator: "clicks", multiplier: 100 } },
  { id: "7", title: "Avg. CPC", key: "average_cpc", category: "Performance", visible: true, isLocked: false, keyType: "number", type: "currency", calculation: { numerator: "cost", denominator: "clicks" } },
  { id: "8", title: "Cost / Conv.", key: "cost_per_conversion", category: "Conversion", visible: true, isLocked: false, keyType: "number", type: "currency", calculation: { numerator: "cost", denominator: "conversions" } },
  { id: "09", title: "Interactions", key: "interactions", category: "Performance", visible: false, isLocked: false, keyType: "number", type: "number" },
  { id: "10", title: "Interaction Rate", key: "interaction_rate", category: "Performance", visible: false, isLocked: false, keyType: "number", type: "float", calculation: { numerator: "interactions", denominator: "impressions", multiplier: 100 } },
  { id: "90", title: "Avg. CPM", key: "average_cpm", category: "Performance", visible: false, isLocked: false, keyType: "number", type: "currency", calculation: { numerator: "cost", denominator: "impressions", multiplier: 1000 } },
  { id: "91", title: "Avg. Cost", key: "average_cost", category: "Performance", visible: false, isLocked: false, keyType: "number", type: "currency", calculation: { numerator: "cost", denominator: "interactions" } },
  { id: "92", title: "Avg. CPV", key: "average_cpv", category: "Performance", visible: false, isLocked: false, keyType: "number", type: "currency", calculation: { numerator: "cost", denominator: "video_views" } }
];

// group cols
export const GROUP_ADDTABLE_COLUMNS = [
  { id: "0", title: "Group Name", key: "group_name", visible: true, category: "Recommended", isLocked: true, type: "boolean" },
  { id: "1", title: "Clicks", key: "clicks", visible: true, category: "Performance", isLocked: false, type: "number" },
  { id: "2", title: "Conv.", key: "conversions", visible: true, category: "Conversions", isLocked: false, type: "float-no-perc" },
  { id: "3", title: "CTR", key: "ctr", visible: true, category: "Performance", isLocked: false, type: "float", calculation: { numerator: "clicks", denominator: "impressions", multiplier: 100 } },
  { id: "104", title: "Revised Daily Spend", key: "revised_daily_spend", visible: true, category: "Performance", isLocked: false, type: "currency", nonExpand: true },
  { id: "4", title: "Cost", key: "cost", visible: true, category: "Performance", isLocked: false, type: "currency" },
  { id: "5", title: "Impr", key: "impressions", visible: true, category: "Performance", isLocked: false, type: "number" },
  { id: "8", title: "Invalid Clicks", key: "invalid_clicks", visible: false, category: "Performance", isLocked: false, type: "number" },
  { id: "9", title: "Impr.(Top) %", key: "top_impression_percentage", visible: false, category: "Performance", isLocked: false, type: "float" },
  { id: "6", title: "Avg.cost", key: "average_cost", visible: true, category: "Performance", isLocked: false, type: "currency", calculation: { numerator: "cost", denominator: "interactions" } },
  { id: "7", title: "Avg. CPC", key: "average_cpc", visible: true, category: "Performance", isLocked: false, type: "currency", calculation: { numerator: "cost", denominator: "clicks" } },
  { id: "90", title: "Cost / Conv.", key: "cost_per_conversion", visible: false, category: "Conversions", isLocked: false, type: "currency", calculation: { numerator: "cost", denominator: "conversions" } },
  { id: "91", title: "Avg. CPM", key: "average_cpm", visible: false, category: "Performance", isLocked: false, type: "currency", calculation: { numerator: "cost", denominator: "impressions", multiplier: 1000 } },
  { id: "92", title: "Avg. CPV", key: "average_cpv", visible: true, category: "Performance", isLocked: false, type: "currency", calculation: { numerator: "cost", denominator: "video_views" } },
  { id: "93", title: "Conv. Rate", key: "conversion_rate", visible: false, category: "Conversions", isLocked: false, type: "float", calculation: { numerator: "conversions", denominator: "clicks", multiplier: 100 } }
];

// bid strat cols
export const BIDSTRAT_ADDTABLE_COLS = [
  { id: "1", title: "Bid Strategy", key: "bid_strategy_type", visible: true, category: "Strategy", isLocked: true, keyType: "string", type: "boolean" },
  { id: "3", title: "Clicks", key: "clicks", visible: true, category: "Performance", keyType: "number", type: "number" },
  { id: "4", title: "Cost", key: "cost", visible: true, category: "Performance", isCurrency: true, keyType: "number", type: "currency" },
  { id: "5", title: "Impr.", key: "impressions", visible: true, category: "Performance", keyType: "number", type: "number" },
  { id: "7", title: "Interactions", key: "interactions", visible: false, category: "Performance", keyType: "number", type: "number" },
  { id: "6", title: "Interaction Rate", key: "interaction_rate", visible: false, category: "Performance", keyType: "number", type: "percentage", calculation: { numerator: "interactions", denominator: "impressions", multiplier: 100 } },
  { id: "8", title: "Conversions", key: "conversions", visible: true, category: "Conversions", keyType: "number", type: "float-no-perc" },
  { id: "10", title: "Conv. Rate", key: "conversion_rate", visible: true, category: "Conversions", keyType: "number", type: "percentage", calculation: { numerator: "conversions", denominator: "clicks", multiplier: 100 } },
  { id: "11", title: "CTR", key: "ctr", visible: true, category: "Conversions", keyType: "number", type: "percentage", calculation: { numerator: "clicks", denominator: "impressions", multiplier: 100 } },
  { id: "2", title: "Avg. CPC", key: "average_cpc", visible: true, category: "Performance", isCurrency: true, keyType: "number", type: "currency", calculation: { numerator: "cost", denominator: "clicks" } },
  { id: "9", title: "Cost / Conv.", key: "cost_per_conversion", visible: true, category: "Conversions", isCurrency: true, keyType: "number", type: "currency", calculation: { numerator: "cost", denominator: "conversions" } },
  { id: "90", title: "Avg. CPM", key: "average_cpm", visible: false, category: "Performance", keyType: "number", type: "currency", calculation: { numerator: "cost", denominator: "impressions", multiplier: 1000 } },
  { id: "91", title: "Avg. Cost", key: "average_cost", visible: false, category: "Performance", keyType: "number", type: "currency", calculation: { numerator: "cost", denominator: "interactions" } },
  { id: "92", title: "Avg. CPV", key: "average_cpv", visible: false, category: "Performance", keyType: "number", type: "currency", calculation: { numerator: "cost", denominator: "video_views" } }
];


// gender
export const GENDER_ADDTABLE_COLUMNS = [
  { id: "0", title: "Gender", key: "gender", category: "Recommended", visible: true, isLocked: true, keyType: "string", type: "boolean" },
  { id: "11", title: "Impr.", key: "impressions", category: "Performance", visible: true, isLocked: false, keyType: "number", type: "number" },
  { id: "2", title: "CTR", key: "ctr", category: "Performance", visible: true, isLocked: false, keyType: "number", type: "percentage", calculation: { numerator: "clicks", denominator: "impressions", multiplier: 100 } },
  { id: "3", title: "Cost", key: "cost", category: "Performance", visible: true, isLocked: false, keyType: "number", type: "currency" },
  { id: "4", title: "Clicks", key: "clicks", category: "Performance", visible: true, isLocked: false, keyType: "number", type: "number" },
  { id: "6", title: "Conversions", key: "conversions", category: "Conversion", visible: true, isLocked: false, keyType: "number", type: "float-no-perc" }
];

// age cols
export const AGE_ADDTABLE_COLUMNS = [
  { id: "0", title: "Age Range", key: "age_range", visible: true, category: "Recommended", locked: true, isLocked: true, keyType: "string", type: "boolean" },
  { id: "1", title: "Impr.", key: "impressions", category: "Performance", visible: true, isLocked: false, keyType: "number", type: "number" },
  { id: "2", title: "Clicks", key: "clicks", visible: true, category: "Performance", isLocked: false, keyType: "number", type: "number" },
  { id: "3", title: "Cost", key: "cost", visible: true, category: "Performance", isLocked: false, keyType: "number", type: "currency" },
  { id: "4", title: "CTR", key: "ctr", visible: true, category: "Performance", isLocked: false, keyType: "number", type: "float", calculation: { numerator: "clicks", denominator: "impressions", multiplier: 100 } },
  { id: "5", title: "Avg. CPC", key: "average_cpc", category: "Performance", visible: false, isLocked: false, keyType: "number", type: "currency", calculation: { numerator: "cost", denominator: "clicks" } },
  { id: "6", title: "Interactions", key: "interactions", visible: false, category: "Performance", isLocked: false, keyType: "number", type: "number" },
  { id: "7", title: "Int. Rate", key: "interaction_rate", visible: false, category: "Performance", isLocked: false, keyType: "number", type: "float", calculation: { numerator: "interactions", denominator: "impressions", multiplier: 100 } },
  { id: "8", title: "Conversions", key: "conversions", visible: true, category: "Conversion", isLocked: false, keyType: "number", type: "float-no-perc" },
  { id: "9", title: "Conv. rate", key: "conversion_rate", visible: false, category: "Conversion", isLocked: false, keyType: "number", type: "float", calculation: { numerator: "conversions", denominator: "clicks", multiplier: 100 } },
  { id: "10", title: "Cost/Conv", key: "cost_per_conversion", visible: false, category: "Conversion", isLocked: false, keyType: "number", type: "currency", calculation: { numerator: "cost", denominator: "conversions" } },
  { id: "90", title: "Avg. CPM", key: "average_cpm", visible: false, category: "Performance", isLocked: false, keyType: "number", type: "currency", calculation: { numerator: "cost", denominator: "impressions", multiplier: 1000 } },
  { id: "91", title: "Avg. Cost", key: "average_cost", visible: false, category: "Performance", isLocked: false, keyType: "number", type: "currency", calculation: { numerator: "cost", denominator: "interactions" } },
  { id: "92", title: "Avg. CPV", key: "average_cpv", visible: false, category: "Performance", isLocked: false, keyType: "number", type: "currency", calculation: { numerator: "cost", denominator: "video_views" } }
];